import {createAction} from "@reduxjs/toolkit";

export const clearPnlState = createAction("pnl/clearState");

export const resetMoveLoader = createAction('pnl/resetMoveLoader')